import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AgentChatRequest {
  question: string;
  sessionId: string;
}

export interface AgentChatResponse {
  success: boolean;
  answer: string;
  warnings: string[];
  errorMessage: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AgentChatService {
  private readonly _http = inject(HttpClient);
  private readonly _url = `${environment.apiBaseUrl}/api/wellview-agent/ask`;

  ask(request: AgentChatRequest): Observable<AgentChatResponse> {
    return this._http.post<AgentChatResponse>(this._url, request);
  }
}
